import {
    Component
} from "@fingerprintjs/fingerprintjs";

// Lists down combinations of mimetypes for audio and video codecs to be tested
function getMediaSourceMimeTypes(): string[] {
    const videoCodecs = [
        "avc1.42E01E", "avc1.58A01E", "avc1.4D401E", "avc1.640028", // H.264
        "vp8", "vp9", "vp9.0.115", // VP8 and VP9
        "hev1.1.6.L93.B0", "hvc1.1.6.L93.B0", // HEVC (H.265)
        "av01.0.01M.08", // AV1
        "theora" // Theora
    ];

    const audioCodecs = [
        "mp4a.40.2", "mp4a.40.5", "mp4a.67", // AAC
        "opus", // Opus
        "vorbis", // Vorbis
        "flac", // FLAC
        "ac-3", "ec-3", // Dolby Digital and Dolby Digital Plus
        "mp3", // MP3
        "pcm", // PCM
        "speex" // Speex
    ];

    const videoFormats = ["video/mp4", "video/webm", "video/ogg"];
    const audioFormats = ["audio/mp4", "audio/webm", "audio/ogg"];

    const mimeTypes: string[] = [];

    // Check video codec combinations
    videoFormats.forEach(format => {
        videoCodecs.forEach(codec => {
            const mimeType = `${format}; codecs="${codec}"`;
            mimeTypes.push(mimeType);
        });
    });

    // Check audio codec combinations
    audioFormats.forEach(format => {
        audioCodecs.forEach(codec => {
            const mimeType = `${format}; codecs="${codec}"`;
            mimeTypes.push(mimeType);
        });
    });

    return mimeTypes;
}

// GetAllowedCodecs - Implements the interface GetCustomComponent
export async function GetAllowedCodecs(): Promise < Component < unknown >> {
    return new Promise(resolve => {
        const startTime = Date.now();
        const mimeTypes = getMediaSourceMimeTypes();
        const hashValue = mimeTypes.filter((mimeType) => MediaSource.isTypeSupported(mimeType));

        resolve({
            value: hashValue,
            duration: Date.now() - startTime
        });
    });
}
